(function () {
  'use strict';

  function carouselDescription () {
    function link (scope) {
      scope.$watch('option', function (val) {
        if (val && val.icon) { //will through an error due to linking otherwise
          scope.iconIsSVG = val.icon.endsWith('.svg');
        }
      });
    }

    return {
      'restrict': 'E',
      'templateUrl': 'components/shared/custom-carousel/carousel-description.html',
      'link': link,
      'scope': {
        'option': '=',
        'page': '=',
        'language': '=',
        'addresstype': '=',
        'targettype': '='
      }
    };
  }

  angular.module('web2print.shared')
    .directive('carouselDescription', carouselDescription);
})();
